import { t } from "@/i18n-js/instance";

const blockTypeI18nRoot = "builder_ui.block_type";

export const HEADING_LEVELS = [
  {
    label: t([blockTypeI18nRoot, "h1"]),
    value: "h1",
    actionView: "h1TextStyles",
  },
  {
    label: t([blockTypeI18nRoot, "h2"]),
    value: "h2",
    actionView: "h2TextStyles",
  },
  {
    label: t([blockTypeI18nRoot, "h3"]),
    value: "h3",
    actionView: "h3TextStyles",
  },
  {
    label: t([blockTypeI18nRoot, "h4"]),
    value: "h4",
    actionView: "h4TextStyles",
  },
  {
    label: t([blockTypeI18nRoot, "h5"]),
    value: "h5",
    actionView: "h5TextStyles",
  },
  {
    label: t([blockTypeI18nRoot, "h6"]),
    value: "h6",
    actionView: "h6TextStyles",
  },
];

export const PARAGRAPH_LEVELS = [
  {
    label: t([blockTypeI18nRoot, "p1"]),
    value: "p1",
    actionView: "p1TextStyles",
  },
  {
    label: t([blockTypeI18nRoot, "p2"]),
    value: "p2",
    actionView: "p2TextStyles",
  },
  {
    label: t([blockTypeI18nRoot, "p3"]),
    value: "p3",
    actionView: "p3TextStyles",
  },
];
